import {List, Map} from 'immutable';
import React from 'react';
import {CallSpeaker} from '@components/call-card/CallSpeaker';
import {PctDouble, Seconds} from '@store/@types/util';
import './CallSpeakerMini.sass';
import IntervalTree from 'node-interval-tree';
import {DragStatus, Speaker, SpeakerNumber} from '@store/call-card/CallCard.types';
import {PlayerProps, PlayerTickGuideId} from '@components/call-card/Player.utils';
import Divider from '@material-ui/core/Divider';
import {MatchLocation} from './TranscriptMatch.utils';
import {MiniSpeakerNumber} from '@components/call-card/CallSpeaker.utils';
import User from 'records/User';
import {CircleTextAvatar} from '@components/util/UserAvatar';
import {SetState} from '@store/@types/util/React';

interface CallSpeakerMiniProps extends PlayerProps {
  segmentTree: IntervalTree<SpeakerNumber, Seconds>;
  speakerTracks: Map<SpeakerNumber, string> | undefined;
  talkTime: Map<SpeakerNumber, Seconds>;
  setTimePct: (pct: PctDouble) => void;
  speakerMatches: Map<SpeakerNumber, List<MatchLocation>>;
  sessionUser?: User;
  dragStatus: DragStatus;
  setDragStatus: SetState<DragStatus>;
}

const speaker: Speaker = {
  speakerNumber: MiniSpeakerNumber,
  hasAvatar: false,
  color: '',
  description: '',
};

/**
 * Renders a combined display of each speaker track
 */
export const CallSpeakerMini: React.FC<CallSpeakerMiniProps> = ({
  segmentTree,
  speakerTracks,
  talkTime,
  setTimePct,
  speakerMatches,
  sessionUser,
  dragStatus,
  setDragStatus,
  ...playerProps
}) => {
  return (
    <div className="call-speaker-mini">
      <CallSpeaker
        speaker={speaker}
        speakerTree={segmentTree}
        talkTime={talkTime.get(speaker.speakerNumber) ?? 0}
        speakerTrack={speakerTracks?.get(speaker.speakerNumber) ?? ''}
        setTimePct={setTimePct}
        matchLocations={speakerMatches.get(speaker.speakerNumber, List())}
        avatarOverride={
          sessionUser && <CircleTextAvatar content={talkTime.size - 1} color={sessionUser.color} />
        }
        hideInfo={true}
        dragStatus={dragStatus}
        setDragStatus={setDragStatus}
        {...playerProps}
      />
      <Divider id={PlayerTickGuideId} />
    </div>
  );
};
